export class SaasEntity {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "externalId",
            "baseName": "externalId",
            "type": "string",
            "format": ""
        },
        {
            "name": "displayName",
            "baseName": "displayName",
            "type": "string",
            "format": ""
        },
        {
            "name": "properties",
            "baseName": "properties",
            "type": "SaasEntityProperties",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "SaasEntityType",
            "format": ""
        },
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "terminated",
            "baseName": "terminated",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "hasSnapshot",
            "baseName": "hasSnapshot",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "latestCaptureOutcome",
            "baseName": "latestCaptureOutcome",
            "type": "SaasCaptureOutcome",
            "format": ""
        },
        {
            "name": "latestCaptureReason",
            "baseName": "latestCaptureReason",
            "type": "SaasCaptureReason",
            "format": ""
        },
        {
            "name": "latestCaptureSnapshotTime",
            "baseName": "latestCaptureSnapshotTime",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return SaasEntity.attributeTypeMap;
    }
    constructor() {
    }
}
